import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Fade from '@mui/material/Fade';
import Box from '@mui/material/Box';

const darkTheme = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContent: {
    // backgroundColor: '#000',
    padding: '24px', // Increased padding
    borderRadius: '8px',
    color: '#ccc',
    width: '80%', // Increased width
    // maxHeight: '80%', // Set maximum height
    overflowY: 'auto', // Enable vertical scrolling if needed
  },
  documentCard: {
    backgroundColor: '#444',
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '16px',
  },
};

const BookmarkModal = (props) => {
  //console.log("opening the bookamrk modal", props)
  

  return (
      <Modal
        open={props.isBookmarkModalOpen}
        onClose={props.handleCloseBookmarkModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        closeAfterTransition
        // BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        sx={darkTheme.modal}
        id="bookmark-modal"
      >
        <Fade in={props.isBookmarkModalOpen}>
          <Box  sx={darkTheme.modalContent} >
          <div className="modal-dialog modal-dialog-centered">
            <div className="border modal-content-1 upgrade-modal-content login_modal_wrapper" >
              <div className="modal-header">
                <h5 className="modal-title">Add dashboard to bookmarks</h5>
                <button type="button" className="btn-close btn-close-white left-col-space text-white" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body text-center">
                <p>Add name and description for bookmark.</p>
                <div className="search-input-box d-flex justify-content-center" id="bookmark-name-section">
                  <input type="text" className="form-control " placeholder="Name"  value={props.bookmarkName} onChange={props.handleBookmarkNameChange} style={{width: "90%"}} />
                </div>
                <div id="bookmakr-name-error"  className="form-error-message" style={{fontSize: "15px"}}>{props.bookmarkNameError}</div>
                <div className="search-input-box d-flex justify-content-center mt-3">
                  <textarea rows="10"  type="text" className="form-control" placeholder="Description"  value={props.bookmarkDescription} onChange={props.handleBookmarkDescriptionChange} style={{width: "90%"}}></textarea>
              </div>
              </div>
              <div className="select_box mb-3">
                <label htmlFor="bookmark_grouper" className="form-label">Select Folder</label>
                <div className="stock_select_div">
                    <select  className="custom-form-select" id="bookmark_grouper" value={props.selectedBookmarkFolder} onChange={props.handleChangeBookmarkFolder} >
                      <option value="0" disabled defaultValue>---Select Folder---</option>
                      <option value="0">Create a new folder...</option>
                      {props?.bookmarkFolders?.map((folder) => (
                          <option key={folder.id} value={folder.id}>{folder.title}</option>
                      ))}

                    </select>
                </div>
                <div id="bookmakr-folder-error" className="form-error-message" style={{fontSize: "15px"}}> {props.bookmarkFolderError}</div>
            </div>
              <div className="col m-auto recurring_plan d-flex login_text text-grey mb-4">
                <div className="d-flex">
                    <div className="switch_box box_4 me-2">
                        <div className="input_wrapper">
                            <input type="checkbox" className="switch_4 cursor_p"
                                onChange={props.handleChangeIsBookmarkPublic} checked={props.isBookmarkPublic} />
                            <span className="is_checked">No</span>
                            <span className="is_unchecked">Yes</span>
                        </div>
                      </div>
                </div>
                <label htmlFor="toggle_share" className="cursor_p">
                  Make it public
                </label>
              </div>
              <div className="modal-footer">
                  <button className="btn secondary_btn" onClick={props.handleBookmarkSubmit}>Save</button>
              </div>
            </div>
          </div>
          
          </Box>
      </Fade>
      </Modal>
  );
};

export default BookmarkModal;
